"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _TablePropTypes = require("./TablePropTypes");

var _BrowserTest = require("../../utils/BrowserTest");

var _sizes = require("HubStyleTokens/sizes");

// In IE11, the height grows uncontrollably if not set to a fixed value.
var fixedHeightMixin = (0, _styledComponents.css)(["height:", ";"], _sizes.TABLE_HEADER_HEIGHT);

var StyledContent = _styledComponents.default.div.withConfig({
  displayName: "SortTH_Content__StyledContent",
  componentId: "sc-1et7go1-0"
})(["align-items:center;display:flex;margin-left:", ";text-align:", ";", ";"], function (_ref) {
  var align = _ref.align;
  return align === 'right' && 'auto';
}, function (_ref2) {
  var align = _ref2.align;
  return align === 'right' && 'right';
}, (0, _BrowserTest.isIE11)() ? fixedHeightMixin : null);

var SortTH_Content = function SortTH_Content(_ref3) {
  var align = _ref3.align,
      arrowsNode = _ref3.arrowsNode,
      children = _ref3.children;
  return _react.default.createElement(StyledContent, {
    align: align
  }, children, arrowsNode);
};

SortTH_Content.propTypes = {
  align: _TablePropTypes.alignPropType,
  arrowsNode: _propTypes.default.node,
  children: _propTypes.default.node
};
SortTH_Content.displayName = 'UISortTH_Content';
var _default = SortTH_Content;
exports.default = _default;
module.exports = exports.default;